export enum UsersDataFetchMessages {
  error = "Something went wrong while reaching the server. If this error persists, please contact support.",
  loading = "Loading data...",
  emptyList = "Sorry, there are no results for your search.",
};
